import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Divider,
} from '@material-ui/core';
import { Form } from 'react-final-form';
import CustomDatePicker from 'components/DatePicker';
import { useTranslate } from 'react-admin';
import { isBefore, isAfter } from 'date-fns';

const ExportDialog = ({ open, onClose, onConfirm, loading }) => {
  const translate = useTranslate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [dateError, setDateError] = useState('');

  const handleFromDateChange = (d) => {
    if (toDate && isAfter(d, toDate)) {
      setDateError(translate('To Date must be later or equal to From Date'));
    } else {
      setDateError('');
    }
    setFromDate(d);
  };
  const handleToDateChange = (d) => {
    if (fromDate && isBefore(d, fromDate)) {
      setDateError(translate('To Date must be later or equal to From Date'));
    } else {
      setDateError('');
    }
    setToDate(d);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>
        {translate('export_invoices_report')}
        <Typography variant="body2" color="textSecondary">
          {translate('Export invoices report within a time range')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Form
          onSubmit={() => onConfirm({ date_from: fromDate, date_to: toDate })}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              {/* Last‑month shortcut */}
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={dateError || loading}
                    fullWidth
                    onClick={() =>
                      onConfirm({ date_from: null, date_to: null })
                    }
                  >
                    {translate('export_invoices_last_month')}
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
              {/* Custom date pickers */}
              <Grid container spacing={2} style={{ marginTop: 8 }}>
                <Grid item xs={6}>
                  <CustomDatePicker
                    label={translate('From Date')}
                    value={fromDate}
                    onChange={handleFromDateChange}
                    error={dateError}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomDatePicker
                    label={translate('To Date')}
                    value={toDate}
                    onChange={handleToDateChange}
                    error={dateError}
                    fullWidth
                  />
                </Grid>
              </Grid>
              {dateError && (
                <Typography
                  variant="body2"
                  color="error"
                  style={{ marginTop: 8 }}
                >
                  {dateError}
                </Typography>
              )}
              <DialogActions>
                <Button onClick={onClose} color="secondary" disabled={loading}>
                  {translate('common__cancel')}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  disabled={!!dateError || (!fromDate && !toDate) || loading}
                >
                  {translate('common_export')}
                </Button>
              </DialogActions>
            </form>
          )}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ExportDialog;
